import React, { useState, useEffect, useCallback } from "react";
import DrLogo from "../../static/images/doctorLogo.png";
import {
  injectIntl,
  IntlProvider,
  FormattedRelative,
  useIntl,
} from "react-intl";
import { constants } from "../../Constants";
import { history } from "../../helpers/history";
import {
  capitalizeFirstLetter,
  capitalizeEachFirstLetter,
} from "../../helpers/utils";

const CounsellorListCard = (props) => {
  const intl = useIntl();
  const showProfile = () => {
    history.replace(`/counsellor/profile/${props.v.counsellor_id}`);
  };
  return (
    <div className="sh-counsellor-card">
      <div className="sh-inner">
        <div
          className={`sh-cci-body ${
            props.whitelabel &&
            props.whitelabel.payment_required &&
            "sh-extra-padding"
          }`}
        >
          {props.whitelabel && props.whitelabel.payment_required ? (
            <div className="sh-price-cont">
              <div className="sh-price">
                {intl
                  .formatNumber(
                    props.countryNameState === "pakistan"
                      ? props.v.price_pkr === 0
                        ? "N/A"
                        : props.v.price_pkr
                      : props.v.price_usd == 0
                      ? "N/A"
                      : props.v.price_usd,
                    {
                      style: "currency",
                      currency:
                        props.countryNameState === "pakistan"
                          ? props.v.price_pkr !== 0 && "PKR"
                          : props.v.price_usd !== 0 && "USD",
                    }
                  )
                  .replace(/\D00(?=\D*$)/, "")}
              </div>
              <div className="sh-text">{constants.COUNSELLOR_FEE_TXT}</div>
            </div>
          ) : null}
          <div className="sh-ccard-image">
            <img
              src={props.v.picture == null ? DrLogo : props.v.picture}
              alt=""
            />
          </div>

          <div className="sh-ccard-text">
            <p className="sh-ccard-name" id={`sh_cl_name_${props.id}`}>
              {capitalizeEachFirstLetter(props.v.full_name)}
            </p>
            <p className="sh-ccard-desc">{props.v.area_of_expertise}</p>
            <p className="sh-ccard-desc1">
              {constants.LANGUAGES_TXT}:
              <span>
                {props.v.languages && props.v.languages.length > 0
                  ? props.v.languages.join(", ")
                  : "N/A"}
              </span>
            </p>
          </div>
        </div>
        <div className="sh-cci-footer">
          <div className="sh-btn-cont">
            <button
              onClick={props.createAppointment}
              id={`btnCancelCreateAppointment_${props.id}`}
              className=""
            >
              {constants.BOOK_NOW_TXT}
            </button>
            <button
              onClick={showProfile}
              id={`btnCreateAppointment_${props.id}`}
              className=""
            >
              {constants.VIEW_PROFILE_TXT}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounsellorListCard;



// WEBPACK FOOTER //
// ./src/screens/CounsellorList/CounsellorListCard.js